import * as getters from './getters'

let state = {
  version: '1.1.47',
  build: '1'
}

export default {
  namespaced: true,
  state,
  getters
}
